import React from 'react'

import { InputText } from '../styled'
import { FormContext, type FormInputType } from '../types'

const FormInputNumber: React.FC<{
  input: FormInputType & { type: 'number' }
}> = ({ input }) => {
  const inputRef = React.useRef<HTMLInputElement | null>(null)

  const { name: inputName } = input
  const { submitting, onChange } = React.useContext(FormContext)
  const handleInput = React.useCallback(
    (e: React.SyntheticEvent<HTMLInputElement>) => {
      onChange(inputName, (e.target as HTMLInputElement).valueAsNumber)
    },
    [inputName, onChange]
  )

  return (
    <InputText
      ref={inputRef}
      type="number"
      min={input.min}
      max={input.max}
      name={input.name}
      placeholder={input.placeholder ?? ''}
      disabled={submitting || input.disabled}
      defaultValue={input.initialValue ?? ''}
      onInput={handleInput}
      onWheel={() => inputRef.current?.blur()}
    />
  )
}

export default FormInputNumber
